var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMasterCasd(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.3312 23.7821H11.6797V8.24219H20.3314L20.3312 23.7821Z",
    fill: "#FF5F00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2267 16.012C12.2267 12.8597 13.7034 10.0516 16.003 8.242C14.2623 6.87018 12.1094 6.12564 9.89274 6.12892C4.43223 6.12892 0.00585938 10.5536 0.00585938 16.012C0.00585938 21.4703 4.43223 25.895 9.89274 25.895C12.1095 25.8983 14.2625 25.1538 16.0032 23.7819C13.7038 21.9726 12.2267 19.1644 12.2267 16.012Z",
    fill: "#EB001B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.002 16.012C32.002 21.4703 27.5756 25.895 22.1151 25.895C19.8982 25.8983 17.7449 25.1537 16.0039 23.7819C18.3041 21.9723 19.7809 19.1644 19.7809 16.012C19.7809 12.8595 18.3041 10.0516 16.0039 8.242C17.7449 6.87022 19.898 6.1257 22.115 6.12892C27.5755 6.12892 32.0019 10.5536 32.0019 16.012",
    fill: "#F79E1B"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMasterCasd);
export default __webpack_public_path__ + "static/media/master-casd.6d9091343eaa20c9b0b1b108d31150c6.svg";
export { ForwardRef as ReactComponent };